export default __webpack_public_path__ + "static/media/SapphireWithSparkles.f9253517.png";